import { http } from "./http";

export type NotificationTone = "danger" | "warning" | "info";

/** Alerte de l'en-tête, calculée par le serveur selon le rôle (retards de paiement, budget…). */
export interface AppNotification {
  type: string;
  icon: string;
  tone: NotificationTone;
  title: string;
  detail: string;
  /** Page à ouvrir au clic. */
  link: string;
  count: number;
  /** Empreinte de la situation : une alerte ouverte reste masquée tant qu'elle ne change pas. */
  signature: string;
}

export interface NotificationPreference {
  type: string;
  label: string;
  description: string;
  /** true : l'utilisateur ne veut plus voir ce type d'alerte. */
  muted: boolean;
}

export async function getNotifications(): Promise<AppNotification[]> {
  return (await http.get<{ items: AppNotification[] }>("/notifications")).items;
}

/** Masque des alertes pour l'utilisateur (ouvertes ou effacées) ; renvoie les alertes restantes. */
export async function dismissNotifications(items: AppNotification[]): Promise<AppNotification[]> {
  return (
    await http.post<{ items: AppNotification[] }>("/notifications/dismiss", {
      items: items.map(({ type, signature }) => ({ type, signature })),
    })
  ).items;
}

export function getNotificationPreferences(): Promise<NotificationPreference[]> {
  return http.get<NotificationPreference[]>("/notifications/preferences");
}

export function updateNotificationPreferences(muted: string[]): Promise<NotificationPreference[]> {
  return http.put<NotificationPreference[]>("/notifications/preferences", { muted });
}
